

































import { eventBus } from "@/main";
import * as enums from "@/types/enums";
import { SectionInterface } from "@/types/interfaces";
import moment from "moment";
import Vue from "vue";
import Component from "vue-class-component";
import { mapGetters } from "vuex";
import {
  DisplayModule,
  SectionsModule,
  UsersModule
} from "@/store/store.helper";
import ownerData from "@/components/owner.data/owner.data.vue";
import { Prop } from "vue-property-decorator";
import HtmlDiff from "htmldiff-js";
import deletePopup from "../../delete.popup/delete.popup.vue";

let HtmlDiffer = require("html-differ").HtmlDiffer,
  htmlDiffer = new HtmlDiffer({
    ignoreAttributes: [],
    compareAttributesAsJSON: [],
    ignoreWhitespaces: true,
    ignoreComments: true,
    ignoreEndTags: false,
    ignoreDuplicateAttributes: false
  });

@Component({
  components: {
    "owner-data": ownerData,
    "delete-popup": deletePopup
  }
})
export default class CardText extends Vue {
  @Prop() public section: SectionInterface;
  @Prop() public pageStatus: Number;
  @Prop() public parentSectionId: String;
  @Prop() public isAddingNewArgument: Boolean;
  @Prop() public editor;
  @Prop() public isUserEditor: Boolean;

  private isSwitched = false;
  private dialog = false;
  private mountedFlag: boolean = false;
  private clipFlag: boolean = false;

  @SectionsModule.SectionsGetter private sectionById: (
    string
  ) => SectionInterface[];
  @SectionsModule.SectionsAction private deleteSection;
  @SectionsModule.SectionsAction private updateSection;
  @SectionsModule.SectionsGetter private isDynamicFeed;

  @UsersModule.UsersGetter private userUid;
  @UsersModule.UsersGetter private participantDisplayNameById: (
    string
  ) => string;
  @DisplayModule.DisplayGetter private dateFormatted;
  @DisplayModule.DisplayGetter private showDeleteButton;
  public created() {
    eventBus.$on("switchDisplays", sectionId => {
      if (this.section.id === sectionId) {
        this.isSwitched = !this.isSwitched;
      }
    });
    eventBus.$on("deleteFromParent", async (sectionId) => {
      if (sectionId === this.section.id) {
        const parentSection = this.sectionById(this.parentSectionId)[0];
        let editSuggestions = parentSection.toEdit;
        const index = editSuggestions.indexOf(this.section.id);
        if (index > -1) {
          editSuggestions.splice(index, 1);
        }
        await this.updateSection({
          id: this.parentSectionId,
          updateObject: {
            toEdit: editSuggestions
          }
        })
      }
    });
    if (
      this.pageStatus === enums.FEED_TYPE.toEdit ||
      this.pageStatus === enums.FEED_TYPE.sectionEdited ||
      this.isAddingNewArgument ||
      (this.section.status === enums.SECTION_STATUS.toEdit &&
        this.pageStatus !== enums.FEED_TYPE.toEditSectionSuggestion)
    ) {
      eventBus.$emit("switchDisplays", this.section.id);
    }
    this.$nextTick(() => {
      this.mountedFlag = true;
    });
  }

  private mounted() {
    if(this.$refs.content['clientHeight'] > 80) {
      this.$refs.content['classList'].add('clip');
      this.clipFlag = true;
    }
  }

  private showMore() {
    this.$refs.content['classList'].remove('clip');
    this.clipFlag = false;
  }

  get previousContent() {
    if (!this.editor) {
      const parentSectionId =
        this.parentSectionId !== "0"
          ? this.parentSectionId
          : this.section.parentSectionId;
      this.isAddingNewArgument = false;
      return this.sectionById(parentSectionId)[0]
        ? "contentHtml" in this.sectionById(parentSectionId)[0]
          ? this.sectionById(parentSectionId)[0].contentHtml
          : "<p>" + this.sectionById(parentSectionId)[0].content + "</p>"
        : "";
    } else {
      return this.editor.getHTML();
    }
  }

  /**
   * if page status is toEdit - get the highlighted content
   */
  private getContent() {
    if (this.mountedFlag) {
      return !this.isAddingNewArgument
        ? this.highlightContent(
            this.$refs.sectionContent,
            this.$refs.sectionContentPrev
          )
        : this.highlightContent(
            this.$refs.sectionContentPrev,
            this.$refs.sectionContent
          );
    }
  }

  /**
   * return HTML tag
   * @param {string} newElem
   * @param {string} oldElem
   */
  private highlightContent(newElem, oldElem) {
    let diff = htmlDiffer.diffHtml(newElem.innerText, oldElem.innerText);
    let isEqual = htmlDiffer.isEqual(newElem.innerText, oldElem.innerText);
    let span = "<span>";
    diff.forEach(function(part) {
      const tag = part.added ? "ins" : part.removed ? "del" : "span";
      span += `<${tag}>${part.value}</${tag}>`;
    });
    return span;
  }
}
